var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChekMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.73397C16 3.04825 15.9037 3.31539 15.711 3.53539L8.23741 12.0673L6.83355 13.67C6.64086 13.89 6.40688 14 6.13161 14C5.85634 14 5.62236 13.89 5.42968 13.67L4.0258 12.0673L0.289027 7.80127C0.0963423 7.58137 0 7.31428 0 7C0 6.68572 0.0963423 6.41858 0.289027 6.19858L1.69291 4.59589C1.88559 4.37598 2.11957 4.26603 2.39484 4.26603C2.67011 4.26603 2.90409 4.37598 3.09677 4.59589L6.13161 8.07237L12.9032 0.330006C13.0959 0.110002 13.3299 0 13.6052 0C13.8804 0 14.1144 0.110002 14.3071 0.330006L15.711 1.9327C15.9037 2.1526 16 2.41969 16 2.73397Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChekMark);
export default __webpack_public_path__ + "static/media/chek_mark.1c735fdbcc614457dc0847bca6d244cf.svg";
export { ForwardRef as ReactComponent };